var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFBE2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.425 22.4728L16.0918 6.60397L6.5764 22.4728H25.425ZM17.3229 5.70733L26.797 21.8156C27.3639 22.7794 26.6763 24 25.5665 24H6.43351C5.31829 24 4.63151 22.7686 5.20931 21.805L14.8682 5.69676C15.4281 4.76311 16.771 4.76889 17.3229 5.70733ZM16 17.5C15.4434 17.5 14.9999 17.0623 14.9999 16.5V12C14.9999 11.4377 15.4434 11 16 11C16.5566 11 16.9953 11.4377 16.9953 12V16.5C16.9953 17.0623 16.5566 17.5 16 17.5ZM17 20C17 20.5623 16.5566 21 16 21C15.4434 21 15 20.5623 15 20C15 19.4377 15.4434 19 16 19C16.5566 19 17 19.4377 17 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarning);
export default __webpack_public_path__ + "static/media/alert_warning.f4e9b382ce141673a875e3cc4cdaa3a7.svg";
export { ForwardRef as ReactComponent };